<div>
  <div class="flex items-center">
    <div>
      <div>
        Select a region to see the <span class="font-bold">total</span> commitment/demand/shifts for the next 48 hours
        across <span class="font-bold">all carriers</span>.
      </div>
      <div class="text-gray-600">
        Ignore the generalized messages about adding drivers, I just wanted to use the same component
      </div>
    </div>
    <mat-form-field class="ml-3">
      <mat-label>Select a Region</mat-label>
      <mat-select [formControl]="selectedRegionForm">
        <mat-option *ngFor="let region of (regions$ | async)?.regions; trackBy: 'id' | trackByKey" [value]="region.id">
          {{ region.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox class="ml-2" [formControl]="fiveFControl" color="primary"> 5F Only </mat-checkbox>
  </div>
  <div *ngFor="let region of regionDrivers$ | async; trackBy: 'id' | trackByKey">
    <lohi-shift-chart-v2 [showDemand]="false" [earningsPerDay]="region"></lohi-shift-chart-v2>
  </div>
</div>
